import React, { useEffect, useState } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import {
  Divider,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import moment from 'moment';

import ModalFilterCustomer from 'components/Tvendo/Common/ModalFilterBPartner';
import { wsFindBy } from 'services/WService';
import { roundMony } from 'hooks/Pipe';

export default function NCLeftOvers(props) {
  const { type, dataHeader, handleChange, isSaving, changeAutocomplete, showNotify } = props;

  const [openModalCustomer, setOpenModalCustomer] = useState(false); //Abrir modal
  const [customerSelect, setCustomerSelect] = useState({});

  // #region listados api
  const [zones, setZones] = useState([]);
  /* const [sellers, setSellers] = useState([]); */
  const [seller, setSeller] = useState({});
  /* const [docTypes, setDocTypes] = useState([]); */
  /* const [paymentTerms, setPaymentTerms] = useState([]);
  const [canals, setCanals] = useState([]); */
  const [reasons, setReasons] = useState([]);

  async function listZones() {
    let response = await wsFindBy('base/zone', { is_base: 'Y' }); //TODO agregar parametro para traer solo 3 sonas
    if (response.success) setZones(response.data);
  }

  async function listSellers(idZone) {
    let response = await wsFindBy('base/seller', {
      base_zone_id: idZone,
      seller_type: 'O' /* ,
      with_customers: true */,
    });
    if (response.success) {
      if (response.data?.length > 0) {
        setSeller(response.data[0]);
        changeAutocomplete('base_seller_id', response.data[0].id, { base_zone_id: idZone });
      } else {
        showNotify('Esta zona no tiene vendedor asignado', 'info');
        setSeller({});
      }
    }
  }

  /* async function listDocTypes() {
    let response = await wsGetAll('base/document-type');
    if (response.success) setDocTypes(response.data);
  } */

  /* async function listPaymentTerms() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) setPaymentTerms(response.data);
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  } */

  async function listReasons() {
    let response = await wsFindBy('base/reason', 'group', '2');
    if (response.success) setReasons(response.data);
  }
  // #endregion

  useEffect(() => {
    listZones();
    /* listDocTypes();
    listPaymentTerms();
    listCanals(); */
    listReasons();
  }, []);

  useEffect(() => {
    if (customerSelect) {
      changeAutocomplete('base_business_partner_id', customerSelect.id, {
        /* base_customer_route_id: customerSelect.base_customer_route_id, */
        base_address_id: customerSelect.base_address_id,
      });
    }
  }, [customerSelect]);

  useEffect(() => {
    if (dataHeader.base_zone_id) listSellers(dataHeader.base_zone_id);
    if (dataHeader.base_business_partner_id) setCustomerSelect(dataHeader);
  }, [dataHeader.U_SYP_MDTD]);

  return (
    <>
      {type === 'NCL' ? (
        <ModalFilterCustomer
          key={dataHeader.base_zone_id}
          open={openModalCustomer}
          setOpen={setOpenModalCustomer}
          cardType="C"
          entity={`base/zone/${dataHeader.base_zone_id}/customers`}
          filterProps={{ base_zone_id: dataHeader.base_zone_id }}
          setBPartnerSelect={setCustomerSelect}
        />
      ) : undefined}
      <GridContainer>
        <GridItem xs={12} lg={12}>
          <h5 style={{ fontWeight: 400 }}>Nota de crédito</h5>
          <Divider style={{ marginTop: '5px', marginBottom: '10px' }} />
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="Fecha Contable 1"
            margin="normal"
            name="DocDate"
            type="date"
            onChange={handleChange}
            value={moment().format('YYYY-MM-DD') || ''}
            InputLabelProps={{ shrink: true }}
            sise="small"
            fullWidth
            disabled={isSaving}
          />
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="Fecha documento"
            margin="normal"
            name="TaxDate"
            type="date"
            onChange={handleChange}
            value={moment().format('YYYY-MM-DD') || ''}
            InputLabelProps={{ shrink: true }}
            sise="small"
            fullWidth
            disabled={isSaving}
          />
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          {/* <Autocomplete
            options={zones}
            disableClearable
            getOptionLabel={(option) => option.description}
            renderInput={(params) => (
              <TextField {...params} label="Zonas" margin="normal" required />
            )}
            onChange={(e, item) => {
              if (!!item) {
                changeAutocomplete('base_zone_id', item.id);
                listSellers(item.id);
                setCustomerSelect({});
              }
            }}
          /> */}
          <FormControl fullWidth margin="normal" size="small" required>
            <InputLabel>Zonas</InputLabel>
            <Select
              value={dataHeader.base_zone_id || ''}
              inputProps={{
                name: 'base_zone_id',
                onChange: handleChange,
              }}
              disabled={isSaving}
            >
              {zones.map((item, i) => {
                return (
                  <MenuItem
                    value={item.id}
                    key={i}
                    onClick={() => {
                      listSellers(item.id);
                      setCustomerSelect({});
                    }}
                  >
                    {item.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <input type="hidden" value={seller.id || ''} name="base_seller_id" />
          <TextField
            key={dataHeader.base_zone_id}
            label="Vendedor"
            margin="normal"
            value={seller.SlpName || ''}
            sise="small"
            fullWidth
            inputProps={{ readOnly: true }}
            required
          />
        </GridItem>
        {type === 'NCL' ? (
          <GridItem xs={12} md={4} lg={2}>
            <TextField
              label="Cliente"
              type="search"
              value={customerSelect.CardName || ''}
              margin="normal"
              inputProps={{ readOnly: true }}
              required
              disabled={type === 'NCL'}
              fullWidth
            />
          </GridItem>
        ) : 
          <GridItem xs={12} md={4} lg={2}>
            <TextField
              key={dataHeader.base_seller_id + openModalCustomer}
              label="Cliente"
              type="search"
              value={customerSelect.CardName || ''}
              margin="normal"
              inputProps={{ readOnly: true }}
              required
              disabled={type === 'NCL'}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    style={{ cursor: 'pointer', color: '#07c107' }}
                    onClick={() => {
                      setOpenModalCustomer(true);
                    }}
                    position="start"
                    disablePointerEvents={!!dataHeader.base_seller_id && !isSaving ? false : true}
                  >
                    <Search />
                  </InputAdornment>
                ),
              }}
              fullWidth
            />
          </GridItem>
        }
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            key={dataHeader.base_seller_id + openModalCustomer}
            label="Dirección"
            margin="normal"
            value={customerSelect.Address2 || ''}
            sise="small"
            fullWidth
            inputProps={{ readOnly: true }}
            required
          />
        </GridItem>
        {/* <GridItem xs={12} md={4} lg={2}>
          <FormControl fullWidth margin="normal" size="small" required key={docTypes}>
            <InputLabel>Tipo documento</InputLabel>
            <Select
              value={dataHeader.base_document_type_id || 2}
              inputProps={{
                name: 'base_document_type_id',
                onChange: handleChange
              }}
            >
              {docTypes.map((item, i) => {
                return (
                  <MenuItem value={item.id} key={i}>
                    {item.description_short}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem> */}
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            key={dataHeader.base_seller_id + openModalCustomer}
            label="Término pago"
            margin="normal"
            value="Contado"
            size="small"
            fullWidth
            inputProps={{ readOnly: true }}
            required
          />
          {/* <FormControl fullWidth margin="normal" size="small" required key={paymentTerms}>
            <InputLabel>Término de pago</InputLabel>
            <Select
              value={dataHeader.base_payment_term_id || 1}
              inputProps={{
                name: 'base_payment_term_id',
                onChange: handleChange
              }}
            >
              {paymentTerms.map((item, i) => {
                return (
                  <MenuItem value={item.id} key={i}>
                    {item.PymntGroup}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl> */}
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            key={dataHeader.base_seller_id + openModalCustomer}
            label="Canal"
            margin="normal"
            value="Minorista"
            size="small"
            fullWidth
            inputProps={{ readOnly: true }}
            required
          />
          {/* <FormControl fullWidth margin="normal" size="small" required key={canals}>
            <InputLabel>Canal</InputLabel>
            <Select
              value={dataHeader.base_canal_id || '1'}
              inputProps={{
                name: 'base_canal_id',
                onChange: handleChange
              }}
            >
              {canals.map((item, i) => {
                return (
                  <MenuItem value={item.id} key={i}>
                    {item.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl> */}
        </GridItem>
        {/* <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="% Descuento"
            margin="normal"
            name="DiscPrcnt"
            type="number"
            onChange={handleChange}
            onBlur={(e) => calcTotal(e.target.value)}
            value={dataHeader.DiscPrcnt || ''}
            inputProps={{ min: 0, max: 100 }}
            sise="small"
            fullWidth
          />
        </GridItem> */}
        <GridItem xs={12} md={4} lg={2}>
          <FormControl fullWidth margin="normal" size="small" required key={reasons}>
            <InputLabel>Razón prioridad</InputLabel>
            <Select
              value={dataHeader.base_reason_id_priority || '8'}
              inputProps={{
                name: 'base_reason_id_priority',
                onChange: handleChange,
              }}
              disabled={isSaving}
            >
              {reasons.map((item, i) => {
                return (
                  <MenuItem value={item.id} key={i}>
                    {item.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            multiline
            label="Comentario"
            fullWidth
            name="comment"
            margin="normal"
            size="small"
            defaultValue={dataHeader.comment}
            disabled={isSaving}
          />
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="Descuento"
            margin="normal"
            name="digitate_discount"
            onChange={handleChange}
            value={roundMony(dataHeader.digitate_discount).toFixed(2)}
            type='number'
            inputProps={{ step: 0.01, style: {textAlign: 'right'} }}
            sise="small"
            fullWidth
          />
        </GridItem>        
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="Monto bruto"
            margin="normal"
            name="gross_amount"
            onChange={handleChange}
            value={roundMony(dataHeader.gross_amount).toFixed(2)}
            /* defaultValue="0" */
            inputProps={{ readOnly: true, step: 0.01, style: {textAlign: 'right'} }}
            sise="small"
            fullWidth
          />
        </GridItem>
        <GridItem xs={12} md={4} lg={2}>
          <TextField
            label="Monto total"
            margin="normal"
            name="DocTotal"
            onChange={handleChange}
            value={roundMony(dataHeader.DocTotal).toFixed(2)}
            /* defaultValue="0" */
            inputProps={{ readOnly: true, step: 0.01, style: {textAlign: 'right'} }}
            sise="small"
            fullWidth
          />
        </GridItem>
      </GridContainer>
    </>
  );
}
